<div class="container">
	<div class="row main">
		<div class="text-fields col-xs-12 col-sm-12 col-lg-6">

			<h1>
				<i *ngIf="userData.estado==='1'" class="fa fa-user userIconFilterCurrent">
					<i class="fa fa-check" style="color: green"></i>
				</i>
				<i *ngIf="userData.estado==='0'" class="fa fa-user userIconFilterCurrent">
					<i class="fa fa-ban" style="color:red"></i>
				</i>
				<i *ngIf="userData.estado==='2'" class="fa fa-user userIconFilterCurrent">
					<i class="fa fa-clock-o" style="color:blueviolet"></i>
				</i>
				<i *ngIf="userData.estado==='3'" class="fa fa-user userIconFilterCurrent">
					<i class="fa fa-close" style="color: red"></i>
				</i>
				{{ modelService.getString('user_profile_title') }}
			</h1>

			<form class="form-horizontal" #profileForm="ngForm">

				<div class="form-group">
					<label for="empresa" class="cols-sm-2 control-label">{{ modelService.getString('company') }}
						<span class="mandatory">*</span>
					</label>
					<div class="input-group">
						<span class="input-group-text" id="iconEmpresa"><i class="fa fa-users" aria-hidden="true"></i></span>
						<input required type="text" class="form-control" name="empresa" id="empresa"
							[(ngModel)]="userData.empresa" placeholder="{{ modelService.getString('company_input') }}"
							aria-label="Username" aria-describedby="iconEmpresa">
					</div>
				</div>

				<div class="form-group">
					<label for="username" class="cols-sm-2 control-label">{{ modelService.getString('vat_number') }}
						<span class="mandatory">*</span>
					</label>
					<div class="input-group">
						<span class="input-group-text" id="iconUsername"><i class="fa fa-balance-scale" aria-hidden="true"></i></span>
						<input required type="text" class="form-control" name="username" id="username"
							[(ngModel)]="userData.cif_nif" placeholder="{{ modelService.getString('vat_number_input') }}"
							aria-label="Username" aria-describedby="iconUsername" />
					</div>
				</div>
				<!-- EMAIL -->
				<div class="form-group">
					<label for="email" class="cols-sm-2 control-label">{{ modelService.getString('datos_email') }} <span
							class="mandatory">*</span></label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-envelope fa" aria-hidden="true"></i></span>
						<input required disabled type="email" class="form-control" name="email" id="email"
							[(ngModel)]="userData.email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
							placeholder="{{ modelService.getString('datos_email_input') }}" />
					</div>
				</div>
				<!-- NOMBRE -->
				<div class="form-group">
					<label for="nombre" class="cols-sm-2 control-label">{{ modelService.getString('name') }}</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-user fa" aria-hidden="true"></i></span>
						<input type="text" class="form-control" name="nombre" id="nombre" [(ngModel)]="userData.nombre"
							placeholder="{{ modelService.getString('name_input') }}" />
					</div>
				</div>
				<!-- APELLIDOS -->
				<div class="form-group">
					<label for="apellidos"
						class="cols-sm-2 control-label">{{ modelService.getString('surname') }}</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-user fa" aria-hidden="true"></i></span>
						<input type="text" class="form-control" name="apellidos" id="apellidos"
							[(ngModel)]="userData.apellidos"
							placeholder="{{ modelService.getString('surname_input') }}" />
					</div>
				</div>
				<!-- CÓDIGO RIVISA -->
				<div *ngIf="modelService.getUser().getData().rol===1 || modelService.getUser().getData().rol===11" class="form-group">
					<label for="codrivisa"
						class="cols-sm-2 control-label">{{ modelService.getString('client_number') }}</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-key fa" aria-hidden="true"></i></span>
						<input type="text" class="form-control" minlength="5" maxlength="5" id="codrivisa"
							name="codrivisa" [(ngModel)]="userData.numCliRivisa" pattern="[0-9]+"
							placeholder="{{ modelService.getString('client_number_input') }}" />
					</div>
				</div>

				<!-- PASSWORD -->
				<div class="form-group" *ngIf="myself()">
					<label for="password"
						class="cols-sm-2 control-label">{{ modelService.getString('password_profile') }}</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-lock fa-lg" aria-hidden="true"></i></span>
						<input #password1 type="password" class="form-control" name="password" id="password"
							[(ngModel)]="userData.password" minlength="4" maxlength="10"
							placeholder="{{ modelService.getString('password_profile_input') }}" />
					</div>
				</div>
				<!-- PASSWORD cuando es el mismo, puede modficicar su password -->
				<div class="form-group" *ngIf="myself()">
					<label for="confirm"
						class="cols-sm-2 control-label">{{ modelService.getString('password2_profile') }}</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-lock fa-lg" aria-hidden="true"></i></span>
						<input #password2 type="password" class="form-control" name="confirm" id="confirm"
							[(ngModel)]="userData.password2" pattern="{{userData.password}}" minlength="4"
							maxlength="10" placeholder="{{ modelService.getString('password2_profile_input') }}" />
					</div>
				</div>
				<!-- CAMBIAR EL IDIOMA -->
				<!-- <div class="form-group">
					<label for="idioma" class="cols-sm-2 control-label">Idioma</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fas fa-language" aria-hidden="true"></i></span>
						<select class="form-control" name="idioma" id="idioma" [(ngModel)]=userData.idioma 
						pattern = "{userData.idioma}">
						
							<option value="es">Español</option>
							<option value="fr">Frances</option>
							<option value="cat">Catalan</option>
							<option value="en">Inglés</option>
						</select>
					</div>
				</div> -->
				<!-- BOTONES -->
				<div class="form-group " style="margin-top: 35px;">
					<!-- ACTUALIZAR DATOS -->
					<button *ngIf="userData.estado!=='3'" type="button" class="btn btn-primary btn-lg btn-block login-button"
						[disabled]="!profileForm.form.valid || loading"
						(click)="updateProfile()">
						<span *ngIf="!loading"> {{ modelService.getString('user_profile_submit') }} </span>
						<i *ngIf="loading" class="fa fa-spinner spin"></i>
					</button>
					<!-- BORRAR USUARIO, solo SuperAdmin y que no se a el mismo -->
					<button *ngIf="systemDeleteUsers()"
						type="button" class="btn btn-danger btn-lg btn-block login-button" (click)="deleteUser()">
						<span *ngIf="!loading"> {{ modelService.getString('user_profile_deleteBotton') }} </span>
						<i *ngIf="loading" class="fa fa-spinner spin"></i>
					</button>
					<!-- Restaurar usuario eliminado, el usuario debe estar en estado eliminado -->
					<button *ngIf="systemDeleteUsers() && userData.estado === '3'"
						type="button" class="btn btn-primary btn-lg btn-block login-button" (click)="recoverUser()">
						<span *ngIf="!loading"> {{ modelService.getString('user_profile_restoreBotton') }} </span>
						<i *ngIf="loading" class="fa fa-spinner spin"></i>
					</button>
				</div>
			</form>
		</div>

		<!-- Mi propio usuario, puedo subir y eliminar imagen -->
		<div *ngIf="myself()" class="image-upload col-xs-12 col-sm-12 col-lg-6">
			<form>
				<div class="form-group">
					<fieldset class="form-group">
						<div class="custom-file fileInputProfileWrap">
							<input type="file" (change)="fileChangeEvent($event)" class="fileInputProfile">
							<div class="img-space">
								<div>
									<img [hidden]="!isImageSaved" id='idlogo' #idlogo [src]="userImageURL" />
								</div>
								<div>
									<i [hidden]="isImageSaved" style="opacity: .6;"
										class="img-responsive fa fa-upload fa-4x"></i>
								</div>
							</div>
						</div>
					</fieldset>
				</div>
				<div class="img-info">
					<p>{{ errorMessage }}</p>
					<i [hidden]="!isImageSaved" style="opacity: .6;" class="fa fa-trash-o fa-2x"
						(click)="removeImage()"></i>
				</div>
			</form>
		</div>

		<!-- Otro usuario, solo puedo ver sus datos -->
		<div *ngIf="!myself()" class="image-upload col-xs-12 col-sm-12 col-lg-6">
			<form>
				<div class="form-group">
					<fieldset class="form-group">
						<div class="custom-file fileInputProfileWrap">
							<div class="img-space">
								<div>
									<img [hidden]="!isImageSaved" id='idlogo' #idlogo [src]="userImageURL" />
								</div>
							</div>
						</div>
					</fieldset>
				</div>
			</form>
		</div>

		<div class="row main"> </div>

	</div>

	<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
		integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo" crossorigin="anonymous">
</script>
</div>

<app-alert #alertWindow ></app-alert>